import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import checkAuth from "./system/auth/authenticate.js";
Vue.use(Router);

// create new router

const routes = [
  {
    path: "/",
    redirect: "/web",
  },
  {
    path: "/web",
    component: () => import("./views/menu"),
    redirect: "/web",
    children: [
      {
        path: "",
        beforeEnter: checkAuth,
        component: () => import("./views/menu/homepage"),
      },
      // {
      //   path: "chat",
      //   beforeEnter: checkAuth,
      //   component: () => import("./views/menu/chat"),
      // },
      {
        path: "profile",
        beforeEnter: checkAuth,
        component: () => import("./views/profile/profile.vue"),
      },
      // {
      //   path: "sport",
      //   beforeEnter: checkAuth,
      //   component: () => import("./views/menu/sport"),
      // },
      // {
      //   path: "recommend",
      //   beforeEnter: checkAuth,
      //   component: () => import("./views/menu/recommend"),
      // },
      {
        path: "event",
        beforeEnter: checkAuth,
        component: () => import("./views/menu/event"),
      },
    ]

  },
  {
    path: "/game",
    name: 'game2',
    props: true,
    beforeEnter: checkAuth,
    component: () => import("./views/game/game2"),
  },

  {
    path: "/sessions",
    component: () => import("./views/sessions"),
    children: [
      {
        path: "login",
        component: () => import("./views/sessions/signIn"),
      },
      // {
      //   path: "aboutUs",
      //   component: () => import("./views/sessions/aboutUs"),
      // },
      // {
      //   path: "tnc",
      //   component: () => import("./views/sessions/tnc"),
      // },
    ]
  },
  {
    path: "/register",
    component: () => import("./views/sessions/signUp"),
  },

  {
    path: "*",
    component: () => import("./views/pages/notFound")
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "open",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // localStorage.setItem('agentCode', to.params.id);
  // const actualUsername = localStorage.getItem("agentCode") || "";
  // // Detect if navigating to guest path
  // const isGuestRoute = to.path.startsWith('/guest/');
  // const isActualUser = actualUsername !== 'guest';

  // // If navigating to a guest path but already logged in, redirect
  // if (isGuestRoute && isActualUser) {
  //   const correctedPath = to.path.replace('/guest/', `/${actualUsername}/`);

  //   next({ path: correctedPath, replace: false });
  //   return;
  // }

  next();
});


router.afterEach(() => {
  // Remove initial loading
  var content = document.getElementById('top');
  if (content) {
    content.scrollTo({ top: 0, behavior: "smooth" });
  }
  const gullPreLoading = document.getElementById("loading_wrap");
  if (gullPreLoading) {
    gullPreLoading.style.display = "none";
  }
  setTimeout(() => NProgress.done(), 100);
});

export default router;
